/**
 * @author Fernando Ruano
 * @file sagaMiddleware.js
 * @description Saga Middleware
 */

// Dependencies
import createSagaMiddleware from 'redux-saga';

const sagaMiddleware = createSagaMiddleware();

export default sagaMiddleware;
